import React, { useState } from 'react'
import styles from './input.module.css'

export const InputText = (props) => {
  const { id, name, onChange } = props

  return (
    <input
      className={styles.text}
      type="text"
      id={id}
      name={name}
      onChange={onChange}
    />
  )
}

export const InputCheckbox = (props) => {
  const { id, name, label, value, onChange, selected = false } = props

  const [checked, setChecked] = useState(selected)

  const handleChange = () => {
    setChecked(!checked)
    if (onChange) onChange(!checked, id)
  }

  return (
    <label
      id={`${id}-label`}
      htmlFor={`${id}-checkbox`}
      className={styles.checkboxLabelWrapper}
    >
      <input
        className={styles.checkbox}
        type="checkbox"
        id={`${id}-checkbox`}
        name={name}
        value={value}
        checked={checked}
        onChange={handleChange}
      />
      <span className={styles.checkboxLabel}>{label}</span>
    </label>
  )
}
